(function () {
  function initNavigation(navElement) {
    if (!navElement || navElement.dataset.tuyaNavReady === "true") return;

    var buttons = navElement.querySelectorAll("[data-tuya-nav-target]");
    var section = navElement.closest("[data-tuya-section='main-product']");
    if (!section) return;

    var myColumn = navElement.closest(".tuya-main-product__column");
    var tabbedTypes = ["product_description", "product_spec", "product_video", "product_bundle", "product_similar", "product_contact", "product_reviews"];

    function updateTabsVisibility() {
      var isDesktop = window.innerWidth > 1024;
      var activeBtnStillVisible = false;
      var activeBtn = navElement.querySelector(".tuya-product-navigation__btn.is-active");

      buttons.forEach(function (button) {
        var targetType = button.getAttribute("data-tuya-nav-target");
        if (targetType === "all") {
          if (button === activeBtn) activeBtnStillVisible = true;
          return;
        }

        var targetBlock = section.querySelector('[data-block-type="' + targetType + '"]');
        if (!targetBlock) {
          button.style.display = "none";
          return;
        }

        var inSameColumn = myColumn && targetBlock.closest(".tuya-main-product__column") === myColumn;

        if (isDesktop) {
          if (inSameColumn) {
            button.style.display = "";
            if (button === activeBtn) activeBtnStillVisible = true;
          } else {
            button.style.display = "none";
          }
        } else {
          button.style.display = "";
          if (button === activeBtn) activeBtnStillVisible = true;
        }
      });

      if (!activeBtnStillVisible) {
        var allBtn = navElement.querySelector('[data-tuya-nav-target="all"]');
        if (allBtn) {
          allBtn.click();
        }
      }
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var targetType = button.getAttribute("data-tuya-nav-target");
        var isDesktop = window.innerWidth > 1024;

        buttons.forEach(function (btn) {
          btn.classList.toggle("is-active", btn === button);
        });

        var blocks = section.querySelectorAll("[data-block-type]");
        blocks.forEach(function (block) {
          var blockType = block.getAttribute("data-block-type");
          if (!tabbedTypes.includes(blockType)) {
            return;
          }

          var inSameColumn = myColumn && block.closest(".tuya-main-product__column") === myColumn;

          if (isDesktop) {
            if (!inSameColumn) {
              block.style.display = "";
              return;
            }

            if (targetType === "all") {
              block.style.display = "";
            } else {
              if (blockType === targetType) {
                block.style.display = "";
              } else {
                block.style.display = "none";
              }
            }
          } else {
            if (targetType === "all") {
              block.style.display = "";
            } else {
              if (blockType === targetType) {
                block.style.display = "";
              } else {
                block.style.display = "none";
              }
            }
          }
        });

        if (typeof window.dispatchEvent === "function") {
          window.dispatchEvent(new Event("resize"));
        }

        var headerHeight = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--tuya-header-group-height')) || 80;
        var navTop = navElement.getBoundingClientRect().top + window.pageYOffset;
        
        if (Math.abs(window.pageYOffset - (navTop - headerHeight - 16)) > 10) {
          window.scrollTo({
            top: navTop - headerHeight - 16,
            behavior: "smooth"
          });
        }
      });
    });

    updateTabsVisibility();
    window.addEventListener("resize", updateTabsVisibility);

    navElement.dataset.tuyaNavReady = "true";
  }

  function initAllNavigations(scope) {
    var root = scope || document;
    root.querySelectorAll(".tuya-product-navigation").forEach(initNavigation);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAllNavigations(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAllNavigations(event.target);
  });
})();
